'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('tvs_paddock_reportspec', {
      url: '/tvs_paddock_reportspec',
      template: '<tvspaddockreportspectab></tvspaddockreportspectab>'
    });
}
